exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.graph[data-v-0a0615a7] {\n  margin-bottom: 20px;\n  height: 95%;\n  border: 1px solid rgb(220, 220, 220);\n}\n", ""]);

// exports
